import Swal from 'sweetalert2';
import { authHeader } from './authHeader';
import { obtenerEmbedYoutube } from './youtube';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Licenciaturas = {
    obtenerLicenciatura: async slug => {
        let url = url_json + "/licenciatura/slug/" + slug
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarLicenciatura: async (data, id) => {
        const result = await Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar la licenciatura?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        });
        if (result.isDenied) {
            Swal.fire('Modificación cancelada', 'El campo quedo intacto', 'success');
            return;
        }
        if (!result.isConfirmed) return;

        let url = url_json + "/licenciatura/" + id;
        // slug no se envía: la API no permite cambiarlo
        let body = {
            inicio: data.inicio,
            video: data.video ? obtenerEmbedYoutube(data.video) ?? data.video : '',
            mostrar_proximo_inicio: Boolean(data.mostrar_proximo_inicio),
            proximo_inicio: [data.proximo_inicio?.[0] ?? '', data.proximo_inicio?.[1] ?? ''],
            mes_ingreso_anual: data.mes_ingreso_anual ?? '',
            horario: data.horario,
            horario_nota: data.horario_nota ?? '',
            charla_activa: Boolean(data.charla_activa),
            charla_titulo: data.charla_titulo ?? '',
            charla_mensaje: data.charla_mensaje ?? '',
            charla_boton: data.charla_boton ?? '',
            semestre: data.semestre.map(({ nombre, data }) => ({ nombre, data }))
        };
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Licenciatura modificada correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar la licenciatura: ' + [].concat(res.message).join(', '),
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    }
}

export default Licenciaturas;
